export default "__VITE_ASSET__KgjjuEUg__"